const eventsMapper = action => {
  switch (action.type) {
    default:
      return null;
  }
};
export default eventsMapper;
